import { Spin } from 'antd'
import ModalUser from 'components/molecules/user/ModalUser'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ReferenceRegulationModal = ({ show, closeModal, isLoading, data, referenceRegulationState }) => {
  const { t } = useTranslation()
  const getRegulationTitle= (reference) => {
    return t('regulation_documents.' + reference.trim().toLowerCase().replace(/\s+/g, "_"))

  }
    
  return (
    <ModalUser
      titleComponent={<div className="flex justify-start items-center pb-5"></div>}
      show={show}
      width={900}
      onClose={closeModal}
      closable={false}>
      <div className="flex justify-between flex-grow flex-col gap-4 max-h-[528px] h-full overflow-hidden overflow-y-auto">
        {isLoading ? (
          <div className="w-full h-full flex flex-col justify-center items-center">
            <Spin />
            <div className="mt-2">{referenceRegulationState.number} - {t('Caricamento in corso...')}</div>
          </div>
        ) : (
          <div className="flex flex-col gap-8">
            {data?.map((file, idx) => (
              <div className="flex flex-col gap-4" key={`reference-${idx}`}>
                <span className="font-medium text-xl">
                  Articolo {referenceRegulationState.number}
                </span>
                <p>{file?.content}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </ModalUser>
  )
}

export default ReferenceRegulationModal
